import { LotLiveData } from "@/app/api/auctions/[auctionId]/gridData/route";
import LotIdentifierInfo from "@/app/components/LotIdentifierInfo";
import LotValueInfo from "@/app/components/LotValueInfo";
import { cn, formatCurrency } from "@/lib/utils";
import { AuctionState, Lot } from "@prisma/client";
import { Flex, Text } from "@radix-ui/themes";
import classNames from "classnames";
import React, { useEffect, useState } from "react";

interface Props {
  lot: Lot;
  auctionState: AuctionState;
  polledData: LotLiveData;
}

const LotPreviewInfo = ({ lot, auctionState, polledData }: Props) => {
  return (
    <Flex direction="column" className="w-full">
      <LotIdentifierInfo lot={lot} />
      <LotValueInfo
        lot={lot}
        auctionState={auctionState}
        polledData={polledData}
      />
    </Flex>
  );
};

export default LotPreviewInfo;
